<style scoped lang="less">
  @import './choose.less';
</style>
<style lang="less">
  @import './chooseScoped.less';
</style>
<template>
  <el-dialog
    class="my-el-dialogs my-examRoom-dialog myChooseExamRoom"
    size="large"
    custom-class="dialog-choose-myChooseExamRoom"
    :visible.sync="is_show"
    :close-on-click-modal="false" :width="configWidth+'px'">
    <div class="choosePersonType">
        <a href="javascript:;" class="active">{{config.caption}}</a>
    </div>
    <div class="choose_main">
      <!-- <div class="choose_left">
      </div> -->
      <div class="choose_right">
        <div class="choose_list" :style="'width:'+ (configWidth - 220) +'px'">
          <div class="seach_box">
            <div class="seach">
              <div class="el-input el-input-group el-input-group--append">
                <input type="text" placeholder="请输入内容" autocomplete="off" @keyup.13="search" v-model="input5" class="el-input__inner">
                <div class="el-input-group__append">
                  <button type="button" @click="search" class="el-button el-button--default"><i class="el-icon-search"></i></button>
                </div>
              </div>
            </div>
            <div class="more">
              <a href="javaScript:;" @click="open_close" >更多<i class="el-icon-arrow-down" :class="{ 'el-icon-arrow-up':isAs, 'el-icon-arrow-down': !isAs}"></i></a>
            </div>
          </div>
          <div class="based_display" :class="{ 'display_no' : isA, 'display': !isA}" style="height: 124px;overflow: auto">
            <el-form>
              <!--<el-form-item label="学校：" style="margin-bottom: 0">-->
                <!--<el-button :type="primary_A" size="small" @click="ck_schoolAll(true)">全部</el-button>-->
                <!--<el-button :type="schoolId==sec.schoolId?'primary':'text'" size="small" v-for="(sec,index) in school" :id="sec.schoolId" @click="ck_school(sec,index,true)">{{ sec.schoolName }}</el-button>-->
              <!--</el-form-item>-->
              <el-form-item label="校区：" style="margin-bottom: 0">
                <el-button :type="primary_A" size="small" @click="ck_campusAll(true)">全部</el-button>
                <el-button :type="campusId==sec.key?'primary':'text'" size="small" v-for="(sec,index) in campus" :key="sec.key" :id="sec.key" @click="ck_campus(sec,index,true)">{{ sec.value }}</el-button>
              </el-form-item>
              <el-form-item label="年级：" style="margin-bottom: 0">
                <el-button :type="primary_B" size="small" @click="ck_gradeAll(true)">全部</el-button>
                <el-button :type="gradeId==sec.key?'primary':'text'" size="small" v-for="(sec,index) in grade" :key="sec.key" :id="sec.key" @click="ck_grade(sec,index,true)">{{ sec.value }}</el-button>
              </el-form-item>
              <el-form-item label="课程：" style="margin-bottom: 0">
                <el-button :type="primary_C" size="small" @click="ck_courseAll(true)">全部</el-button>
                <el-button :type="courseId==sec.key?'primary':'text'" size="small" v-for="(sec,index) in course" :key="sec.key" :id="sec.key" @click="ck_course(sec,index,true)">{{ sec.value }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="padding: 10px 10px 0px 10px" class="myTable">
            <el-table
              :data="searchArea.tableData.aaData"
              v-loading="loading"
              border
              element-loading-text="拼命加载中"
              ref="multipleTable"
              @select="handleSelectionChange"
              @select-all="allselect"
              :height="ht" class="org_table">
              <el-table-column type="selection" width="38px">
              </el-table-column>
              <el-table-column
                prop="roomAddr"
                label="物理地址" show-overflow-tooltip width="200">
              </el-table-column>
              <el-table-column
                prop="maxNumber"
                label="最大容量" show-overflow-tooltip width="100">
              </el-table-column>
              <el-table-column
                prop="campusName"
                label="考场校区" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="check_info" :style="'width:'+leftWidth+'px'">
          <div class="selected-personnel">已选教室({{personList.length}})<i class="el-icon-delete" @click="clearAll"></i> </div>
          <ul class="person_list">
            <template v-for="(pn,index) in personList">
              <li><a href="javascript:;" :title="pn.roomAddr"><span>{{pn.roomAddr}}</span> <i class="el-icon-close" @click="unChoose(pn,index)"></i></a></li>
            </template>
          </ul>
        </div>
        <div class="footer">

          <el-pagination
            @size-change="orgSizeChange"
            @current-change="tableQuery.page = $event, search($event)"
            :total="searchArea.tableData.iTotalRecords"
            :page-size="tableQuery.size"
            :current-page.sync="tableQuery.page"
            layout="->, total, sizes, prev, pager, next, jumper">
          </el-pagination>


            <!-- <el-pagination
              @size-change="orgSizeChange"
              @current-change="tableQuery.page = $event, search()"
              :total="searchArea.tableData.iTotalRecords"
              :page-size="tableQuery.size"
              :current-page="tableQuery.page"
              layout="->, total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
          <el-button type="primary" @click="config.confirm(personList),is_show = false">确定(已选{{personList.length}}个)</el-button>
          <el-button @click="is_show = false">取消</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        loading: true,
        is_show: false,
        input5:"",
        isA: false,
        isAs: false,
        isCutPage:false,
        tableQuery: {
          page: 1,
          size: 10,
          draw: 0,
          filter:{
            examPlanId:"",
            schoolId:"",
            campusId:"",
            sectionId:"",
            gradeId:"",
          },
        },
        ht:"492",
        circleTableQuery: {
          page: 1,
          length: 10,
          draw: 0,
          filter:{
            gradationId:'',
//            schoolId:'',
            gradeId:'',
            courseId:'',
            roleCode:'',
            pinYin:'',
            groupId:'',
            keyWord:'',
          },
        },
        primary_A:'primary',
        primary_B:'primary',
        primary_C:'primary',
        primary_D:'primary',
        primary_E:'primary',
        course:[],
        courseId:'',
        school:[],
        schoolId:"",
        campus:[],
        campusId:"",
        section:[],
        sectionId:"",
        grade:[],
        gradeId:"",
        config: {
          multi: true,
          confirm: function() {},
          left: [],
          selected: [],
        },
        searchArea: {
          tableQuery: {
            page: 1,
            length: 10,
            draw: 0,
            order: '',
            filter: {
              isIncludeChild: 0,
              keywords: '',
              status: '',
              selected: [],
              orgId: '',
            },
          },
          tableData: {
            aaData: [],
            draw: 0,
            iTotalDisplayRecords: 0,
            iTotalRecords: 0,
          },
        },
        personList:[],
        selectedData:[],
        ruleForm: {
          campus:[],
          gradation:[],
          grade:[],
          school:[]
        },
        configVal:"",
        isCrossSchool:'',
        schoolList:[],
        campusList:[],
        courseList:[],
        examSchoolInfo:[],
        examDataInfo:[],
        configWidth:'1000',
        leftWidth:'220'
      }
    },
    created(){
      Array.prototype.remove = function(val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };//移除数组元素方法
      Array.prototype.unique1 = function(){
        var res = [this[0]];
        for(var i = 1; i < this.length; i++){
          var repeat = false;
          for(var j = 0; j < res.length; j++){
            if(this[i].id == res[j].id){
              repeat = true;
              break;
            }
          }
          if(!repeat){
            res.push(this[i]);
          }
        }
        return res;
      };//去重
    },
    methods: {
      open_close(){
        // 查看更多
        this.isA = !this.isA;
        this.isAs = !this.isAs;
        this.isA ? this.ht="368":this.ht="492";
      },
      choose(){
      },
      chooseLetter(val){
        let vm=this;
        let _this=$(event.target);
        if(_this.hasClass("active")){
          vm.pinYin="";
          _this.removeClass("active")
        }else {
          vm.pinYin=val;

          _this.addClass("active").siblings("a").removeClass("active");
        }
        vm.search();
      },
//      ck_school(item,type){
//        let vm=this;
//        // 选择学校
//        if(vm.isCrossSchool!=0) {
//          this.schoolId = this.school[type].schoolId;
//          this.campusId = "";
//          this.sectionId = "";
//          this.gradeId = "";
//          this.primary_A = "text";
//          this.primary_B = 'primary';
//          this.primary_C = 'primary';
//          this.primary_D = 'primary';
//          vm.campuss();
//        }
//      },
//      ck_schoolAll(type){
//        let vm=this;
//        if(vm.isCrossSchool!=0){
//          this.schoolId="";
//          this.campusId="";
//          this.sectionId="";
//          this.gradeId="";
//          this.primary_A="primary";
//          this.primary_B='primary';
//          this.primary_C='primary';
//          this.primary_D='primary';
//            vm.campuss();
//        }
//      },
      ck_campus(item,type){
        // 选择校区
        let vm=this;
//        if(vm.isCrossSchool!=0) {
          this.campusId = this.campus[type].key;
          this.courseId = "";
          this.gradeId = "";
          this.primary_A = 'text';
          this.primary_B = 'primary';
          this.primary_C = 'primary';
          vm.grades();
//        }
      },
      ck_campusAll(type){
        // 选择校区
        let vm=this;
//        if(vm.isCrossSchool!=0) {
          this.campusId = "";
          this.courseId = "";
          this.gradeId = "";
          this.primary_A = 'primary';
          this.primary_B = 'primary';
          this.primary_C = 'primary';
          vm.grades();
//        }
      },
//      ck_section(item,type){
//        let vm=this;
//        // 选择学段
//        this.sectionId=this.section[type].gradaTionId;
//        this.gradeId="";
//        this.primary_C='text';
//        this.primary_D='primary';
//        this.gradeId="";
//        vm.grades();
//      },
//      ck_sectionAll(type){
//        let vm=this;
//        this.sectionId="";
//        this.gradeId="";
//        this.primary_C='primary';
//        this.primary_D='primary';
//        this.gradeId="";
//        vm.grades();
//      },
      ck_grade(item,type){
        let vm=this;
        // 选择年级
        this.gradeId=this.grade[type].key;
        this.courseId="",
        this.primary_B="text";
        this.primary_C="primary";
        vm.courses();
      },
      ck_gradeAll(type){
        let vm=this;
        this.gradeId="";
        this.primary_B="primary";
        this.primary_C="primary";
        vm.courses();
      },
      ck_course(item,type){
        let vm=this;
        // 选择年级
        this.courseId=this.course[type].key;
        this.primary_C="text";
        vm.search();
      },
      ck_courseAll(type){
        let vm=this;
        this.courseId="";
        this.primary_C="primary";
        vm.search();
      },
      orgSizeChange(v){
        let vm=this;
        vm.tableQuery.size=v;
        vm.search();
      },
      unChoose(pn,index){
        let vm = this;
        let ii=vm.personList[index];
        var n=vm.personList.length;
        for (let j=0;j<vm.searchArea.tableData.aaData.length;j++){
          if(ii.id==vm.searchArea.tableData.aaData[j].id){
            vm.searchArea.tableData.aaData[j].querySelected = false;
            vm.$nextTick(function () {
              vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], false);
            })
          }
        }
        for (var j=0;j<n;j++){//删除缓存结果数据
          if(vm.personList[j].id==ii.id){
            vm.personList.splice(j,1);
            n=n-1;
          }
        }
        let d=vm.selectedData.length;
        for (var g=0;g<d;g++){//删除中间缓存数据
          if(vm.selectedData[g].id==pn.id){
            vm.selectedData.splice(g,1);
            d=d-1;
          }
        }
      },
      clearAll(){
        let vm=this;
        if(vm.personList.length>0){
          vm.selectedData=[];
          vm.personList=[];
          vm.search();
        }
      },
      search(val){
        let vm = this;
        vm.loading=true;
        if(!val){
          vm.tableQuery.page = 1
        }
        vm.tableQuery.filter.schoolId = vm.schoolId ? vm.schoolId : '';
        vm.tableQuery.filter.campusId =vm.campusId ? vm.campusId : '';
        vm.tableQuery.filter.sectionId = vm.sectionId ? vm.sectionId : '';
        vm.tableQuery.filter.gradeId = vm.gradeId ? vm.gradeId : '';
        vm.tableQuery.filter.roomAddr = vm.input5;
        let query = $.extend({}, vm.tableQuery, {
          filter: eduFilterParam(vm.tableQuery.filter), /*vm.roomFilter.name*/
        });
        http.get(InterfacePrefix['platform'] + '/api/selectPeople/classroom',{params:query})
          .then(function (xhr) {
            _.each(xhr.data.aaData, function(vv) {
              vv.querySelected = false
              vv.deSelected = false
            });
            vm.searchArea.tableData = xhr.data.data;
//            if(vm.searchArea.tableData.aaData.length>0) {
//              _.forEach(vm.searchArea.tableData.aaData, function (n, index) {
//                _.forEach(vm.examSchoolInfo, function (l) {
//                  if(n!=null){
//                      if(l==n.id) {
//                        vm.searchArea.tableData.aaData.splice(index,1);
//                      }
//                  }
//                })
//              })
//            }
            vm.$nextTick(function () {
              for(let i=0;i<vm.personList.length;i++){//回显
                for (let j=0;j<vm.searchArea.tableData.aaData.length;j++){
                  if(vm.personList[i].id==vm.searchArea.tableData.aaData[j].id){
                    vm.searchArea.tableData.aaData[j].querySelected = true;
                    vm.$nextTick(function () {
                      vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], true);
                    })
                  }
                }
              }
            });
            setTimeout(() => {
              vm.loading=false;
            }, 500)
          })
      },
      allselect(val){
        let vm=this;
        let el=true;
        if(val.length>0){
          _.each(vm.searchArea.tableData.aaData, function(vv) {
            vv.querySelected = true
            vm.handleSelectionChange(el,vv,1);
          });
        }else {
          _.each(vm.searchArea.tableData.aaData, function(vv) {
            vv.querySelected = false;
            vm.handleSelectionChange(el,vv,2);
          });
        }
      },
      handleSelectionChange(e,v,s){
        let vm = this;
        let checked=e==true?e:!v.querySelected;
        if(s){
          s==1?checked=true:checked=false;
        }
        if(checked) {//是否勾选
          for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
            if (v.id == vm.searchArea.tableData.aaData[j].id) {
              vm.searchArea.tableData.aaData[j].querySelected = true;
              vm.$nextTick(function () {
                vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], true);
              })
            }
          }
        }
        let list = _.filter(vm.searchArea.tableData.aaData, function(vv) {
          return vv.querySelected;
        });
        if(checked){//是否勾选
          let b=[];
          if (list.length!=0){
            let aa=list.length;
            for(var j=0;j<aa;j++){//合并数据
              vm.selectedData.push(list[j]);
            }
          }
          b=vm.selectedData;
          if(vm.selectedData.length>1){
            vm.selectedData=b.unique1();
          }else {
            vm.selectedData=b;
          }
        }else {
          for (let j=0;j<vm.searchArea.tableData.aaData.length;j++){
            if(v.id==vm.searchArea.tableData.aaData[j].id){
              vm.searchArea.tableData.aaData[j].querySelected = false;
              vm.$nextTick(function () {
                vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], false);
              })
            }
          }
          let s=vm.selectedData.length;
          for (var h=0;h<s;h++){//删除中间缓存数据
            if(vm.selectedData[h].id==v.id){
              vm.selectedData.splice(h,1);
              s=s-1;
              h=h-1;
            }
          }
        }
        if(vm.selectedData.length>1){
          vm.personList=vm.selectedData.unique1();
        }else {
          vm.personList=vm.selectedData;
        }
      },
      query(){
        let vm = this;
        http.get(vm.configVal.firstLine).then(function(xhr) {
          vm.campus=[];
          vm.campus = xhr.data.data;
          vm.grades();
        });
//        let vm=this;
//        let query = {
//          schoolId:vm.schoolId,
//        };
//        http.get(vm.configVal.secondLine,{params:query}).then(function(xhr) {
//          vm.campus=[];
//          if(vm.isCrossSchool==0){
//            vm.campusList = xhr.data.data;
//            _.forEach(vm.campusList,function (n) {
//              if(n.campusId==vm.campusId)vm.campus.push(n);
//            });
//          }else{
//            vm.campus = xhr.data.data;
//          }
//          vm.sections();
//        });
      },
//      campuss(){
//        let vm=this;
//        let query = {
//          schoolId:vm.schoolId,
//        };
//        http.get(vm.configVal.secondLine,{params:query}).then(function(xhr) {
//            vm.campus=[];
//          if(vm.isCrossSchool==0){
//            vm.campusList = xhr.data.data;
//            _.forEach(vm.campusList,function (n) {
//              if(n.campusId==vm.campusId)vm.campus.push(n);
//            });
//          }else{
//            vm.campus = xhr.data.data;
//          }
//          vm.sections();
//        });
//      },
      sections(){
        let vm=this;
        let query = {
          schoolId:vm.schoolId,
          campusId:vm.campusId,
        };
        http.get(vm.configVal.thirdLine,{params:query}).then(function(xhr) {
          vm.section = xhr.data.data;
          vm.grades();
        });
      },
      grades(){
        let vm=this;
        let query = {
          campusId:vm.campusId,
        };
        http.get(vm.configVal.secondLine,{params:query}).then(function(xhr) {
          vm.grade = xhr.data.data;
          vm.courses();
        });
      },
      courses(){
        let vm=this;
        let query = {
          gradeId:vm.gradeId,
          campusId:vm.campusId,
        };
        http.get(vm.configVal.thirdLine,{params:query}).then(function(xhr) {
          vm.course = xhr.data.data;
          vm.search();
        });
      }
    },
    watch: {
      config(val){
        let vm=this;
        vm.personList=[];
        _.each(val.seletedData, function(vv) {
          vv.querySelected = true;
        })
        vm.personList=val.seletedData;
        vm.selectedData=val.seletedData;
        vm.tableQuery.filter.examPlanId=val.examPlanId;
        vm.schoolId= val.schoolId;
        vm.campusId= val.campusId;
        vm.gradeId= val.gradeId;
        vm.courseId= val.courseId;
//        if(val.isCrossSchool==1){
//          vm.primary_A="text";
//          vm.primary_B="text";
//        }
        vm.examSchoolInfo=[];
        vm.examSchoolInfo=val.examSchoolInfo;
//        vm.isCrossSchool=val.isCrossSchool;
        vm.configVal=val;
        if(val.width){
          vm.configWidth = val.width
        }
        if(val.leftWidth){
          vm.leftWidth = val.leftWidth
        }
        vm.query();
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/commonplugin/choose/chooseExamRoom.vue